import { getExecEndpoint } from '../../service/getExecEndpoint';
import { SourceBoundingBox } from '~/lib/pdfViewer/types';
import { defaultServer } from '~/api/def/servers/defaultServer';

export const obligationsEndpoint = {
  server: defaultServer,
  path: 'obligations/fund',
  description: 'Get the obligations',
};

const endpointObligationsGetExec =
  getExecEndpoint<ObligationsEndpointDef>(obligationsEndpoint);
export const endpointObligationsGET = async (urlExtra: string) =>
  endpointObligationsGetExec<'GET'>({ method: 'GET', urlExtra });
export interface ObligationsEndpointDef {
  endpoint: typeof obligationsEndpoint;
  methods: {
    GET: {
      response: ObligationsResponse;
    };
  };
}
export type ObligationsResponse = {
  clauses: Clause[];
  filterMeta: FilterMeta;
};
export type FilterMeta = {
  investors: string[];
  funds: {
    name: string;
    id: string;
  }[];
};
export type Clause = {
  documentId: string;
  clauseId: string;
  title: string;
  summary: string;
  sourceBoundingBox: SourceBoundingBox;
  fund: {
    name: string;
    id: string;
  };
  owner: {
    id: string;
    name: string;
  } | null;
  investor: {
    name: string;
  };
};
